<template>
  <div class="overlay__content">
    <slot />
  </div>
</template>

<script>
export default {};
</script>
